import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import {getValueWithVat, getValueWithoutVat} from '../Common/helpers';
import {validateForm, blurValidations} from '../Common/formValidator';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';

class AddEditService extends Component {
    constructor(props) {
        super(props);

        this.state = {
            serviceId:this.props.props.match.params.id
            ,openModal:false
            ,returnTitle: "Erro"
            ,returnText: "Ocorreu algum erro"
            ,editable: (this.props.isAdmin || this.props.loginData.profile.Services.permission === 1)
            ,somethingWasEdited: false
            ,serviceData:null
            ,loggedIn:this.props.isLoggedIn
            ,loading:false
            ,addEditTitle:"Novo Serviço"
            ,name:""
            ,shortname:""
            ,priceWithVat:"0.00"
            ,priceWithoutVat:"0.00"
            ,notes:""
            ,isActive:1
        };
    }
    componentDidMount() {
        if(this.state.serviceId > 0){
            fetch(API + 'getservices&getbyid=' + this.state.serviceId)
            .then(response => response.json())
            .then(result => {
                const serviceData = result.data;

                if(result === null || result.shortmsg === "NOK"){
                    this.props.props.history.push('/Services');
                    return;
                }

                this.setState({ 
                    serviceData
                    , name: serviceData.Name
                    , shortname: serviceData.Shortname
                    , priceWithVat: serviceData.PriceWithVat
                    , priceWithoutVat: serviceData.PriceWithoutVat
                    , notes: serviceData.Notes
                    , isActive: serviceData.IsActive
                });
            });
        }
        blurValidations($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false });
    }

    handleTitleChange = (e) => {this.setState({ [e.target.id]: e.target.value, addEditTitle: e.target.value, somethingWasEdited:true });}
    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0", somethingWasEdited:true });
    handleNumberChange = (e) => {const value=e.target.value>0?e.target.value:0;this.setState({ [e.target.id]: value, somethingWasEdited:true });}
    handlePriceWithoutVAT = (e) => this.setState({ priceWithVat: getValueWithVat(e.target.value, this.props.websiteSettings.VatValue), somethingWasEdited:true });
    handlePriceWithVAT = (e) => this.setState({ priceWithoutVat: getValueWithoutVat(e.target.value, this.props.websiteSettings.VatValue), somethingWasEdited:true });

    handleSave = (e) => {
        if(!this.state.somethingWasEdited)
            return;

        if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false })){
            let DEFAULT_QUERY = "saveservice&serviceid=" + this.state.serviceId + "&name=" + this.state.name.trim() + "&shortname=" + this.state.shortname.trim()
                                + "&pricewithvat=" + this.state.priceWithVat + "&pricewithoutvat=" + this.state.priceWithoutVat
                                + "&notes=" + this.state.notes.trim() + "&isactive=" + this.state.isActive + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;

            this.setState({loading:true});
            fetch(API + DEFAULT_QUERY)
            .then(response => response.json())
            .then(result => {this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false })});
        }
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        this.props.props.history.push('/Services');
    }

    handleDelete = (e) => {
        if(window.confirm("Tem a certeza que quer apagar este serviço?")){
            this.setState({loading:true});

            fetch(API + 'deleteservice&serviceid=' + this.state.serviceId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message, openModal: true, loading:false });
            });
        }
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const { editable } = this.state;
        const addEditTitle = this.state.serviceId > 0 && this.state.serviceData!=null ? this.state.serviceData.Name : this.state.addEditTitle
              , loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <div id="addEditServicePage" ref="editForm" className={"form addEditPage" + loadingClass}>
                <div className="row">
                    <div className="col-12">
                        <h1><i className="fa fa-clipboard-list"></i> {addEditTitle}
                            {(isAdmin || loginData.profile.Services.isActive) && 
                                <span className="float-right">
                                    <FormControlLabel
                                        label="Ativo"
                                        control={
                                            <Switch
                                                id="isActive"
                                                checked={!!+this.state.isActive}
                                                disabled={!(isAdmin || (loginData.profile.Services.isActive.permission === 1 && editable))}
                                                onChange={this.handleToggle}
                                                color="primary"/>
                                        }/>
                                </span>
                            }
                        </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="fieldHolder required">
                            <TextField fullWidth
                                       id="name"
                                       value={this.state.name}
                                       onChange={this.handleFieldChange}
                                       label="Nome"
                                       placeholder="Introduza o nome"
                                       disabled={!editable}
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder required">
                            <TextField fullWidth
                                       id="shortname"
                                       value={this.state.shortname}
                                       onChange={this.handleFieldChange}
                                       label="Abreviatura"
                                       placeholder="Introduza a abreviatura"
                                       disabled={!editable}
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder hidden-md-down">
                            <TextField fullWidth
                                       id="notes"
                                       value={this.state.notes}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       multiline
                                       rows={4}
                                       label="Observações" />
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="fieldHolder moneyHolder">
                            <TextField fullWidth
                                       id="priceWithVat"
                                       value={this.state.priceWithVat}
                                       onChange={this.handleNumberChange}
                                       onBlur={this.handlePriceWithVAT}
                                       label="Preço com IVA"
                                       placeholder="Introduza o Preço com IVA"
                                       disabled={!editable}/>
                        </div>
                        <div className="fieldHolder moneyHolder">
                            <TextField fullWidth
                                       id="priceWithoutVat"
                                       value={this.state.priceWithoutVat}
                                       onChange={this.handleNumberChange}
                                       onBlur={this.handlePriceWithoutVAT}
                                       label="Preço sem IVA"
                                       placeholder="Introduza o Preço sem IVA"
                                       disabled />
                        </div>
                    </div>
                    <div className="col-12 hidden-md-up">
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="notes"
                                       value={this.state.notes}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       multiline
                                       rows={4}
                                       label="Observações" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 buttonsHolder">
                        <Button onClick={this.props.props.history.goBack} className="defaultButton" variant="contained">Voltar</Button>
                        { (isAdmin || loginData.profile.Services.DEL.permission === 1) && this.state.serviceId !== "New" && <Button onClick={this.handleDelete} className="button button-danger" variant="contained">Apagar Serviço</Button>}
                        { editable && <Button onClick={this.handleSave} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default AddEditService;
